var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "li",
    { staticClass: "item", class: { disabled: _vm.disabled, gold: _vm.gold } },
    [
      _c(
        "span",
        { staticClass: "icon" },
        [
          _vm.disabled
            ? _c("w-fa", { attrs: { icon: ["far", "times-circle"] } })
            : _vm.additional
            ? _c("w-fa", {
                staticClass: "additional",
                attrs: { icon: ["fas", "plus-circle"] },
              })
            : _vm.gold
            ? _c("w-fa", { attrs: { icon: ["far", "star"] } })
            : _c("w-fa", { attrs: { icon: ["far", "check-circle"] } }),
        ],
        1
      ),
      _c("span", { class: { bold: _vm.bold } }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }